<div class="flex-column gap-4 animated fadeIn">
    <div class="flex-column gap-2">
        <div class="flex-row gap-2 align-items-center">
            <input type="text" class="m-0 f-1-0" style="height: 32px; max-width: 500px"
                   (keyup.enter)="decodeUrl();"
                   placeholder="Encoded URL"
                   [(ngModel)]="urlTxt">
            <btn-c [isDisabled]="!urlTxt || decodeUrlInProcess" (action)="decodeUrl();">
                Decode
            </btn-c>
        </div>
    </div>
    <div class="flex-column" style="height: 140px; max-width: 700px; font-size: 14px;">
        <loader height="75" width="75" style="opacity: 0.8; align-self: center;" *ngIf="decodeUrlInProcess"></loader>
        <div class="flex-column gap-2 bg-success bg-opacity-10 border border-success rounded-2 p-3"
             *ngIf="decodeUrlResult && !decodeUrlInProcess">
            <div class="flex-row justify-content-between">
                <span>{{decodeUrlResult}}</span>
                <i class="far fa-copy copy-link opacity-75 hvr-opacity" tooltip="Copy URL"
                   style="font-size: 15px;"
                   (click)="gs.copyToClipboard(decodeUrlResult);"></i>
            </div>
        </div>
    </div>
</div>
